import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosApi from "../../utils/httpClient";

const name = "eventkeywords";
const initialState = {
  eventkeywords: [],
  loading: false,
  error: null,
};

export const fetchEventkeywords = createAsyncThunk(
  "eventkeywords/fetchEventkeywords",
  async () => {
    const data = await axiosApi.get(`${process.env.REACT_APP_BASE_URL}keyword`);
    return data.data;
  }
);

const eventkeywordsSlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchEventkeywords.pending, (state) => {
      state.eventkeywords = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchEventkeywords.fulfilled, (state, action) => {
      state.eventkeywords = action.payload.data;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(fetchEventkeywords.rejected, (state, action) => {
      state.eventkeywords = [];
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export default eventkeywordsSlice.reducer;
